export interface ConversionFile {
  id: string;
  file: File;
  name: string;
  size: number;
  type: string;
  preview?: string;
  status: 'pending' | 'converting' | 'completed' | 'error';
  progress: number;
  targetFormat: ImageFormat;
  quality: number;
  result?: ConversionResult;
  error?: string;
}

export interface ConversionResult {
  blob: Blob;
  url: string;
  name: string;
  size: number;
  originalSize: number;
  compressionRatio: number;
}

export type ImageFormat = 'png' | 'jpg' | 'webp' | 'avif' | 'gif';

export interface ConversionOptions {
  format: ImageFormat;
  quality: number;
  maxWidth?: number;
  maxHeight?: number;
  keepAspectRatio: boolean;
}

export const SUPPORTED_INPUT_FORMATS = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/avif',
  'image/gif',
  'image/bmp',
  'image/tiff',
  'image/svg+xml',
];

export const OUTPUT_FORMATS: { value: ImageFormat; label: string; extension: string }[] = [
  { value: 'png', label: 'PNG', extension: '.png' },
  { value: 'jpg', label: 'JPEG', extension: '.jpg' },
  { value: 'webp', label: 'WebP', extension: '.webp' },
  { value: 'avif', label: 'AVIF', extension: '.avif' },
  { value: 'gif', label: 'GIF', extension: '.gif' },
];

export function getFileExtension(filename: string): string {
  return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function generateFileId(): string {
  return Math.random().toString(36).substring(2, 15);
}